import { Suspense } from 'react';

import {
  cancelScheduledPopupClose,
  scheduledPopupClose,
  useFoodDetailsPopupStore,
} from '@/components/foodDetailsPopupState';
import { lazyNamed } from '@/components/lazyRoute';

const FoodDetailsPopupLayer = lazyNamed(() => import('@/components/FoodDetailsPopup'), 'FoodDetailsPopupLayer');

/** Mounted once in the app shell; the popup UI itself only loads the first time a food is hovered. */
export const FoodDetailsPopupSingletonContainer = () => {
  const state = useFoodDetailsPopupStore();
  const props = state.props;
  const isVisible = (state.isMouseOverPopup || !!state.isMouseOverTarget) && !!props;
  if (!isVisible || !props) {
    return null;
  }

  return (
    <div
      className="absolute z-notice flex"
      role="group"
      onMouseEnter={() => {
        cancelScheduledPopupClose();
        useFoodDetailsPopupStore.setState({ isMouseOverPopup: true });
      }}
      onMouseLeave={() => {
        scheduledPopupClose();
      }}
    >
      <Suspense fallback={null}>
        <FoodDetailsPopupLayer {...props} />
      </Suspense>
    </div>
  );
};
